import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function Login() {
  const [email, setEmail] = useState('admin@example.com');
  const [password, setPassword] = useState('Admin123!');
  const [message, setMessage] = useState<string | null>(null);
  const navigate = useNavigate();

  async function loginSession(e: React.FormEvent) {
    e.preventDefault();
    setMessage(null);
    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      
      if (!res.ok) {
        // Only allow bypass in development mode for legitimate server errors (5xx)
        // Never bypass for authentication errors (401, 403)
        if (process.env.NODE_ENV === 'development' && res.status >= 500) {
          console.warn('Backend server error in development, allowing dev login');
          navigate('/dashboard');
          return;
        }
        // Authentication failures should always be rejected
        if (res.status === 401 || res.status === 403) {
          throw new Error('Invalid credentials');
        }
        throw new Error(`Login failed with status ${res.status}`);
      }
      
      await res.json();
      navigate('/dashboard');
    } catch (err: any) {
      // Only allow bypass in development for network errors (server completely down)
      // Never bypass for authentication failures
      if (
        process.env.NODE_ENV === 'development' && 
        (err.message.includes('Failed to fetch') || err.message.includes('NetworkError')) &&
        !err.message.includes('401') &&
        !err.message.includes('403')
      ) {
        console.warn('Backend network error in development, allowing dev login');
        navigate('/dashboard');
        return;
      }
      setMessage(err.message || 'Login failed');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-sm border rounded-lg p-6">
        <h1 className="text-2xl font-semibold mb-4">Sign in</h1>
        <form className="space-y-4" onSubmit={loginSession}>
          <div className="grid gap-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <Button type="submit" className="w-full">Login</Button>
        </form>
        {message && <p className="text-sm text-muted-foreground mt-4">{message}</p>}
      </div>
    </div>
  );
}
